import { Button } from '@/components/ui/button'
import useModalStore from '@/stores/useModalStore'
import { Loader2, MessageSquareDashed, MessageSquareDot } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { updateMessage } from '../../graphql/mutation'
import { useMutationGraphQL } from '@/use-graphql'
import { Tooltip } from '@/components/ToolTip'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { toast } from 'react-toastify'

const MarkUnreadButton = ({ id, markedUnread }: { id: string; markedUnread: boolean }) => {
  const queryClient = useQueryClient()
  const { addModal } = useModalStore()
  const { t } = useTranslation()
  const markUnreadMessage = useMutationGraphQL(
    updateMessage,
    { id, input: { markedUnread: !markedUnread } },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['messages'] })
      },
      onError: () => {
        toast.error('Failed to archive message')
      },
    },
  )

  const showConfirmModal = () => {
    addModal({
      name: 'send-email-notification',
      Component: ({ close }) => {
          const [loading, setLoading] = useState(false)
          return (
          <div className="p-10">
            <h3>Do you want to mark this message as {markedUnread ? 'read' : 'unread'}?</h3>
            <div className="mt-10 flex justify-end gap-4">
              <Button
                onClick={async () => {
                  try{
                    setLoading(true)
                    await markUnreadMessage.mutateAsync()
                    setTimeout(() => close?.(), 300)
                  } finally {
                    setLoading(false)
                  }
                }}
                disabled={loading}
                className="relative"
              >
                {t('button.accept')}
                {loading && <Loader2 className="absolute left-2 top-3 animate-spin !text-white" size={20} />}
              </Button>
              <Button variant="outline" onClick={close}>
                {t('button.cancel')}
              </Button>
            </div>
          </div>
        )
      },
      isCardStyle: true,
      maxWidth: 700,
    })
  }

  return (
    <button onClick={showConfirmModal} className="hover:text-brand-valencia">
      <Tooltip
        content={markedUnread ? 'Mark as read' : 'Mark as unread'}
        delayDuration={100}
        className="bg-slate-800/70 text-xs text-white"
      >
        {markedUnread ? <MessageSquareDashed size={20} /> : <MessageSquareDot size={20} />}
      </Tooltip>
    </button>
  )
}

export default MarkUnreadButton
